import { DEFAULT_SCALE_FORMAT } from './scale/barcode'
import { DeviceModel } from './types'

/**
 * Generic models every till has even before the catalog loads (and in the demo). System Admin seeds the same entries
 * and adds real models; a real model of a known protocol needs no code.
 */
export const BUILTIN_MODELS: DeviceModel[] = [
  {
    _id: 'builtin:browser-a4',
    name: 'Regular printer (browser print dialog)',
    type: 'printer',
    roles: ['document', 'receipt', 'label'],
    transports: ['browser'],
    protocol: 'html',
    params: { page: 'a4', width_mm: 80 },
  },
  {
    _id: 'builtin:browser-roll-80',
    name: 'Receipt printer via the browser (80 mm)',
    type: 'printer',
    roles: ['receipt'],
    transports: ['browser'],
    protocol: 'html',
    params: { page: 'roll', width_mm: 72 },
  },
  {
    _id: 'builtin:escpos-80',
    name: 'Generic ESC/POS receipt printer, 80 mm',
    type: 'printer',
    roles: ['receipt', 'cash_drawer'],
    transports: ['webusb', 'webserial', 'http'],
    protocol: 'escpos',
    params: { paper_width_mm: 80, chars_per_line: 48 },
  },
  {
    _id: 'builtin:escpos-58',
    name: 'Generic ESC/POS receipt printer, 58 mm',
    type: 'printer',
    roles: ['receipt', 'cash_drawer'],
    transports: ['webusb', 'webserial', 'http'],
    protocol: 'escpos',
    params: { paper_width_mm: 58, chars_per_line: 32 },
  },
  {
    _id: 'builtin:imin',
    name: 'iMin built-in printer',
    type: 'printer',
    roles: ['receipt', 'cash_drawer'],
    transports: ['imin'],
    protocol: 'escpos',
    params: { paper_width_mm: 80, chars_per_line: 48 },
  },
  {
    _id: 'builtin:tspl',
    name: 'Generic TSPL label printer',
    type: 'label_printer',
    roles: ['label'],
    transports: ['webusb', 'webserial'],
    protocol: 'tspl',
  },
  {
    _id: 'builtin:zpl',
    name: 'Generic ZPL label printer',
    type: 'label_printer',
    roles: ['label'],
    transports: ['webusb', 'webserial', 'http'],
    protocol: 'zpl',
  },
  {
    _id: 'builtin:serial-scale',
    name: 'Generic serial scale (continuous output)',
    type: 'scale',
    roles: ['scale_read'],
    transports: ['webserial'],
    protocol: 'serial_scale',
    scale: {
      frame: {
        baud_rate: 9600,
        pattern: '(?<stable>ST|US),(?:GS|NT),\\s*(?<weight>[-+]?\\d+(?:\\.\\d+)?)\\s*(?<unit>kg|g)',
        stable_value: 'ST',
        unit: 'kg',
      },
    },
  },
  {
    // Not connected to the till: it prints its own labels (`21` + PLU + grams) from a PLU list loaded with its software.
    _id: 'builtin:label-scale-csv',
    name: 'Label-printing scale (CSV PLU list)',
    type: 'scale',
    roles: ['scale_labels'],
    transports: ['browser'],
    protocol: 'none',
    scale: {
      barcode_formats: [DEFAULT_SCALE_FORMAT],
      plu_export: {
        extension: 'csv',
        delimiter: ',',
        header: true,
        encoding: 'utf-8',
        columns: [
          { title: 'PLU', field: 'plu_code' },
          { title: 'Name', field: 'name' },
          { title: 'Unit price', field: 'unit_price' },
          { title: 'Barcode', field: 'barcode' },
        ],
      },
    },
  },
]
